module.exports = __webpack_public_path__ + "media/images/ibu__button__appAndroid-1ab85474895d197d9d11b94ea7a5a79c.svg";